<!--
 * 二次封装ant-design的select组件, 解决value为空字符串时，不显示placeholder的问题
-->
<template>
  <a-select
    v-bind="$attrs"
    v-on="$listeners"
    :placeholder="placeholder"
    :value="isNull(value) ? undefined : value"
  >
    <template slot="default">
      <slot></slot>
    </template>

    <template v-for="(item, key) in $slots" v-slot:[key]="slotScope">
      <slot :name="key" v-bind="slotScope"></slot>
    </template>

  </a-select>
</template>

<script>
export default {
  name: "LinSelect",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {},
    placeholder: {
      default: '请选择'
    },
    loading: {
      type: Boolean,
    }
  },
  data() {
    return {};
  },
  methods: {
    isNull(value) {
      return value === null || value === '' || value === undefined
    },
  }
};
</script>

<style lang="scss" scoped></style>
